// Fields
export const CONCEPT_CREATION_PERIOD = 'conceptCreationPeriod';
export const CREATIVE_CREATION_PERIOD = 'creativeCreationPeriod';
export const CREATIVE_TYPES = 'creativeTypes';
export const LANGUAGES = 'languages';
export const MEDIA_TYPES = 'mediaTypes';
export const ORIENTATIONS = 'orientations';
export const TAGS = 'includeTags';
export const STATUSES = 'statuses';
